import { getConfig } from "@cirrus/config"

export const withBase = (relativeUrl, baseUrl) => {
  if (!relativeUrl && !baseUrl) return ""
  if (relativeUrl.indexOf("~") > -1) relativeUrl = relativeUrl.replace("~", "")

  const base = window.location.protocol + "//" + window.location.host

  return base.concat(baseUrl || getConfig().BaseUrl, relativeUrl)
}
